import React from 'react';

const ReportsComponent = () => {
  return <div></div>;
};

export default ReportsComponent;
